<template src="./paladin-event.html"></template>

<script>
import { ChiRhosNext, ChiRhosV3 } from '@paladin/core'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
// import PaladinLimit from '../../../library/components/limit/paladin-limit'
// import PaladinPersonLookup from '../../../library/components/personlookup/paladin-person-lookup'

import { PaladinLimit, PaladinPersonLookup } from '@paladin/core-components'

import _ from 'lodash'

const ChiRhosNextApi = new ChiRhosNext().api();
const ChiRhosV3Api = new ChiRhosV3().api();

export default {
  components: { Multiselect, PaladinLimit, PaladinPersonLookup, },
  props: {
    allRoles: {
      type: Array,
      required: true,
    },
    groupEntityId: {
     type: String,
     required: true
    },
    event: {
     type: Object,
     default: null
    },
    eventTypes: {
     type: Array,
     default: null
    },
    isRepeatEvent: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      attendanceReport: 'checkedIn',
      attendancePageSize: '10',
      attendancePage: 1,
      attendanceResults: [],
      currentEvent: {},
      eventForm: {
        url: null,
        limit: {},
        isRepeatEvent: false,
        recurrenceType: 'daily',
        endType: 'never',
        durationHours: 0,
        durationMinutes: 30,
        description: null,
        recurrence: {
          occurences: 30,
          endBy: null,
          daily: {
            every: 1,
          },
          weeklyOnDays: {
            sunday: false,
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
          },
          weekly: {
            every: 1,
          },
          monthlyOnDay: {
            day: 0,
            every: 0,
          },
          monthly: {
            dayOfWeek: 0,
            week: 0,
            every: 0,
          },
        },
        type: null,
        name: '',
        start: null,
        minutesDuration: 30,
        address: {},
        registrationOnly: false,
        registrationOpen: null,
        registrationOpenDaysBefore: null,
      },
      positions: [],
      addresses: [],
      addressOption: null,
      messages: [],
      showMessages: false,
    }
  },
  computed: {
    addressOptions: function (){
      return this.addresses.map(item => {
        return {
          value: item.id,
          text: item.group + " - " + item.address.name
        };
      });
    },
  },
  watch: {
    groupEntityId: function() {
      this.$emit('editEventPanelClose')
    },
  },
   created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {
      this.currentEvent = this.event
      this.populate()

      // get any existing addresses
      this.addAddresses(this.addresses, this.groupEntityId, this.generateUUID)
    },
    populate()
    {
      // bind any existing

      if(this.currentEvent.entityId)
      {
        this.eventForm.name = this.currentEvent.name
        this.eventForm.url = this.currentEvent.url
        this.eventForm.description = this.currentEvent.description
        this.eventForm.type = this.currentEvent.type
        this.eventForm.start = moment(this.currentEvent.start).format('YYYY-MM-DDTHH:mm')
        this.eventForm.durationHours = Math.floor(this.currentEvent.minutesDuration / 60)
        this.eventForm.durationMinutes = this.currentEvent.minutesDuration % 60
        this.eventForm.isRepeatEvent = this.isRepeatEvent
        this.eventForm.address = this.currentEvent.address ? this.currentEvent.address : {}
        this.eventForm.registrationOnly = this.currentEvent.registrationOnly
        this.eventForm.registrationOpen = this.currentEvent.registrationOpen ? moment(this.currentEvent.registrationOpen).format('YYYY-MM-DDTHH:mm') : null
        this.eventForm.registrationOpenDaysBefore = this.currentEvent.registrationOpenDaysBefore

        this.eventForm.recurrence.daily.every = 1
        this.eventForm.recurrence.weekly.every = 1
        this.eventForm.recurrence.weeklyOnDays.sunday = false
        this.eventForm.recurrence.weeklyOnDays.monday = false
        this.eventForm.recurrence.weeklyOnDays.tuesday = false
        this.eventForm.recurrence.weeklyOnDays.wednesday = false
        this.eventForm.recurrence.weeklyOnDays.thursday = false
        this.eventForm.recurrence.weeklyOnDays.friday = false
        this.eventForm.recurrence.weeklyOnDays.saturday = false

        this.eventForm.limit = this.currentEvent.limit

        let useSeries = false
        let entityId = this.currentEvent.entityId
        let createPositions = false

        if(this.isRepeatEvent)
        {
          useSeries = true

          if(this.currentEvent.recurrence.daily)
          {
            this.eventForm.recurrenceType = 'daily'
            this.eventForm.recurrence.daily.every = this.currentEvent.recurrence.daily.every
          }
          else if(this.currentEvent.recurrence.weekly)
          {
            this.eventForm.recurrenceType = 'weekly'
            this.eventForm.recurrence.weekly.every = this.currentEvent.recurrence.weekly.every
          }
          else if(this.currentEvent.recurrence.weeklyOnDays)
          {
            this.eventForm.recurrenceType = 'weeklyOnDays'
            this.eventForm.recurrence.weeklyOnDays.sunday = this.currentEvent.recurrence.weeklyOnDays.sunday
            this.eventForm.recurrence.weeklyOnDays.monday = this.currentEvent.recurrence.weeklyOnDays.monday
            this.eventForm.recurrence.weeklyOnDays.tuesday = this.currentEvent.recurrence.weeklyOnDays.tuesday
            this.eventForm.recurrence.weeklyOnDays.wednesday = this.currentEvent.recurrence.weeklyOnDays.wednesday
            this.eventForm.recurrence.weeklyOnDays.thursday = this.currentEvent.recurrence.weeklyOnDays.thursday
            this.eventForm.recurrence.weeklyOnDays.friday = this.currentEvent.recurrence.weeklyOnDays.friday
            this.eventForm.recurrence.weeklyOnDays.saturday = this.currentEvent.recurrence.weeklyOnDays.saturday
          }
            // TODO
        }
        else
        {
          // see if we need use series

          if(entityId === '00000000-0000-0000-0000-000000000000')
          {
            // occurrence, so get series id

            useSeries = true
            entityId = this.currentEvent.belongsToSeries.entityId
            createPositions = true
          }
        }
        // positions

        if(useSeries)
        {
           ChiRhosNextApi.EventSeriesApi.positionList({ entityId: entityId}).then(
            response => {
              if(response.data)
              {
                this.positions = response.data.map(function(e) {
                  var p = e.entity
                  p.registrationOpen = p.registrationOpen ? moment(p.registrationOpen).format('YYYY-MM-DDTHH:mm') : null
                  if(createPositions) { p.create = true }
                  p.limitPreset = _.clone(e.entity.limit, true)
                  p.delete = false
                  return p })
              }
            },
            error => {
              console.error(error)
              error.json().then(body => {
                this.$toast(body.Message, "error")
              })
            }
          )
        }
        else
        {
          ChiRhosNextApi.EventApi.positionList({ entityId: entityId }).then(
            response => {
              if(response.data)
              {
                this.positions = response.data.map(function(e) {
                  var pos = e.entity
                  pos.registrationOpen = pos.registrationOpen ? moment(pos.registrationOpen).format('YYYY-MM-DDTHH:mm') : null
                  pos.users = []
                  pos.limitPreset = _.clone(e.entity.limit, true)
                  pos.create = false
                  pos.delete = false
                  return pos
                })

                // do the position assigns

                if(this.positions)
                {
                  let positions = this.positions

                  // this.positions.forEach(function(position) {
                    ChiRhosNextApi.EventApi.positionAssigned({ entityId: entityId }).then(
                      response => {
                        if(response.data)
                        {
                          positions.forEach(function(position)
                          {

                          position.users = response.data.filter(el => el.entity.belongsTo === position.entityId).map(function(e) {
                            let person = {}

                            person.assignedEntityId = e.entity.entityId
                            person.entityId = e.entity.toPersonEntityId
                            person.firstName = "Loading"
                            person.lastName = "..."
                            person.delete = false
                            person.blocked = ''

                            ChiRhosNextApi.PersonApi.get({ entityId: e.entity.toPersonEntityId }).then(
                              response => {
                                if(response.data)
                                {
                                  person.firstName = response.data.entity.firstName
                                  person.lastName = response.data.entity.lastName
                                }},
                              error => {
                                console.error(error)
                            })

                            ChiRhosV3Api.EventApi.apiEventPositionBlockCheckPost({ apiPersonRequest: { entityId: entityId, personEntityId: e.entity.toPersonEntityId  } }).then(
                              response => {
                                if(response.data && response.data.entity)
                                {
                                  person.blocked = response.data.entity.note ? response.data.entity.note : 'Blocked out'
                                  person.blocked += ' from ' + moment(response.data.entity.fromUtc).local().format('LLLL') + ' to ' + moment(response.data.entity.toUtc).local().format('LLLL')
                                }
                              },
                              error => {
                                console.error(error)
                              }
                            )

                            return person
                          })
                          })
                        }
                      },
                      error => {
                        console.error(error)
                        error.json().then(body => {
                          this.$toast(body.Message, "error")
                        })
                      }
                    )
                  // })
                }
              }
            },
            error => {
              console.error(error)
              error.json().then(body => {
                this.$toast(body.Message, "error")
              })
            }
          )
        }

        // TODO - any more options we support
      }
      else
      {
        this.eventForm.name = null
        this.eventForm.description = null
        this.eventForm.url = null
        this.eventForm.start = null
        this.eventForm.type = null
        this.eventForm.durationHours = 0
        this.eventForm.durationMinutes = 30
        this.eventForm.isRepeatEvent = false
        this.eventForm.recurrenceType = 'daily' // in case we can tick repeat, reset these
        this.eventForm.recurrence.daily.every = 1
        this.eventForm.recurrence.weekly.every = 1
        this.eventForm.recurrence.weeklyOnDays.sunday = false
        this.eventForm.recurrence.weeklyOnDays.monday = false
        this.eventForm.recurrence.weeklyOnDays.tuesday = false
        this.eventForm.recurrence.weeklyOnDays.wednesday = false
        this.eventForm.recurrence.weeklyOnDays.thursday = false
        this.eventForm.recurrence.weeklyOnDays.friday = false
        this.eventForm.recurrence.weeklyOnDays.saturday = false
        this.eventForm.address = {}
        this.eventForm.registrationOnly = false
        this.eventForm.registrationOpen = null
        this.eventForm.registrationOpenDaysBefore = null
        this.eventForm.limit = {}
        this.positions = []

        // TODO - any more options we support
      }
    },
    addAddresses(addresses, groupEntityId, generateUUID)
    {
        let addAddresses = this.addAddresses;

        ChiRhosNextApi.GroupApi.get({ entityId: groupEntityId }).then(
            response => {
              if(response.data.entity.addresses)
              {
                response.data.entity.addresses.forEach(function(item) {
                  addresses.push({ id:generateUUID(), group: response.data.entity.name, address: item })
                })
              }

              if(response.data.entity.belongsTo !== '00000000-0000-0000-0000-000000000000')
              {
                addAddresses(addresses, response.data.entity.belongsTo, generateUUID)
              }
            },
            error => {
              console.error(error);
              error.json().then(body => {
                this.$toast(body.Message, "error")
              })
            }
          )
    },
    loadAddress()
    {
      var item = this.addresses.find(op => {
        return op.id === this.addressOption
      });

      if (item) {
        this.eventForm.address.line1 = item.address.line1
        this.eventForm.address.line2 = item.address.line2
        this.eventForm.address.city = item.address.city
        this.eventForm.address.state = item.address.state
        this.eventForm.address.postalCode = item.address.postalCode
        this.eventForm.address.countryCode = item.address.countryCode
      }
    },
    async saveEvent()
    {
      if(!this.eventForm.type)
      {
        this.$toast('You must select an event type', 'error')
        return
      }

      if(!this.eventForm.name)
      {
        this.$toast('You must select a name', 'error')
        return
      }

      if(!this.eventForm.start)
      {
        this.$toast('You must select a start date and time', 'error')
        return
      }

      var ev = _.clone(this.currentEvent, true)

      ev.type = this.eventForm.type
      ev.name = this.eventForm.name
      ev.start = moment(this.eventForm.start).utc().toISOString()
      ev.minutesDuration = this.eventForm.durationHours * 60 + this.eventForm.durationMinutes * 1
      ev.description = this.eventForm.description
      ev.url = this.eventForm.url
      ev.address = this.eventForm.address
      ev.belongsTo = this.groupEntityId
      ev.limit = this.eventForm.limit
      ev.registrationOnly = this.eventForm.registrationOnly
      ev.registrationOpen = this.eventForm.registrationOpen ? moment(this.eventForm.registrationOpen).utc().toISOString() : null
      ev.registrationOpenDaysBefore = this.eventForm.registrationOpenDaysBefore

      if (this.eventForm.isRepeatEvent)
      {
        ev.recurrence = {}

        // setup recurrence
        if (this.eventForm.recurrenceType === 'daily') {
          ev.recurrence.daily = { every: this.eventForm.recurrence.daily.every }
        } else if (this.eventForm.recurrenceType === 'weekly') {
          // console.log(_recurrence)
          // console.log(this.eventForm.recurrence.weekly)
          ev.recurrence.weekly = { every: this.eventForm.recurrence.weekly.every }
        } else if (this.eventForm.recurrenceType === 'weeklyOnDays') {
          ev.recurrence.weeklyOnDays = this.eventForm.recurrence.weeklyOnDays
          // new DaysOfWeek()
        } else if (this.eventForm.recurrenceType === 'monthly') {
          // not implemented
        } else if (this.eventForm.recurrenceType === 'yearly') {
          // not implemented
        }

        if (this.eventForm.endType === 'never') {
          // do nothing
        } else if (this.eventForm.endType === 'on') {
          ev.recurrence.endBy = this.eventForm.recurrence.endBy
        } else if (this.eventForm.endType === 'after') {
          ev.recurrence.occurences = this.eventForm.recurrence.occurences
        }
      }

      var dirty = true

      if(this.currentEvent.entityId && this.currentEvent.entityId !== '00000000-0000-0000-0000-000000000000')
      {
        // existing event, so see if it's dirty
        dirty = !_.isEqual(ev, this.currentEvent)
      }

      var success = true

      if(dirty)
      {
        // if(this.event && this.currentEvent.entityId)
        // {
        //   ev.entityId = this.currentEvent.entityId

        //   if(this.currentEvent.belongsToSeries && this.currentEvent.belongsToSeries.entityId)
        //   {
        //     // event in a series
        //     ev.belongsToSeries = this.currentEvent.belongsToSeries
        //   }
        // }
        if (!this.eventForm.isRepeatEvent)
        {
          await ChiRhosNextApi.EventApi.post(ev).then(
            response => {
              this.$toast("Event saved", "success")
              ev = response.data.entity
            },
            error => {
              console.error(error)
              error.json().then(body => {
                this.$toast(body.Message, "error")
              })
              success = false
            }
          )
        }
        else
        {
          await ChiRhosNextApi.EventSeriesApi.post(ev).then(
            response => {
              this.$toast("Event series saved", "success")
              ev = response.data.eventSeries.entity
            },
            error => {
              console.error(error)
              error.json().then(body => {
                this.$toast(body.Message, "error")
              })

              success = false
            }
          )
        }
      }
      else
      {
        console.log('no changes, skipping event/series save')
      }

      if(success)
      {
        this.currentEvent = ev

        // now we do positions (if any)

        this.messages = []
        var messages = this.messages

        var parseError = this.parseError

        if(this.positions)
        {
          let promises = []
          let nestedPromises = []

          let entityId = ev.entityId
          let isRepeatEvent = this.eventForm.isRepeatEvent

          this.positions.forEach(function(position)
          {
            if(position.create)
            {
              position.entityId = '00000000-0000-0000-0000-000000000000' // get rid of the temporary id
              position.belongsTo = entityId
            }

            if (!isRepeatEvent)
            {
              if(position.delete)
              {
                promises.push(ChiRhosNextApi.EventApi.positionDelete(position.entityId).then(
                response => {
                  console.log('Event position deleted')
                },
                async error => {
                  let contentType = error.headers.get("content-type")
                  if (contentType && contentType.indexOf("application/json") !== -1)
                  {
                    await error.json().then(body => {
                      messages.push({ position: position.name, action: 'Delete position', text: body.Message })
                      console.log(body.Message)
                    })
                  }
                  else
                  {
                    await error.text().then(body => {
                      messages.push({ position: position.name, action: 'Delete position', text: parseError(body) })
                      console.log(body)
                      })

                  }
                }
                ))
              }
              else
              {
                let assigns = _.clone(position.users, true)
                position.users = null // for security, don't send these with the position

                var positionsClone = _.clone(position, true) // clone so we can set UTC date
                positionsClone.registrationOpen = positionsClone.registrationOpen ? moment(positionsClone.registrationOpen).utc().toISOString() : null

                promises.push(ChiRhosNextApi.EventApi.position(positionsClone).then(
                response => {
                  console.log('Event position saved')
                  if(assigns)
                  {
                      assigns.forEach(function(assign) {
                      if(assign.delete)
                      {
                        nestedPromises.push(ChiRhosNextApi.EventApi.positionUnassign({ entityId: assign.assignedEntityId }).then(
                          response => {
                            console.log('Event position unassigned')
                          },
                          async error => {
                          let contentType = error.headers.get("content-type")
                          if (contentType && contentType.indexOf("application/json") !== -1)
                            {
                              await error.json().then(body => {
                                console.log(body.Message)
                                messages.push({ position: position.name, action: 'Unassign position', text: body.Message, assign: assign })
                              })
                            }
                            else
                            {
                              await error.text().then(body => {
                                console.log(body)
                                messages.push({ position: position.name, action: 'Unassign position', text: parseError(body), assign: assign })
                                })

                            }}
                          ))
                      }
                      if(!assign.assignedEntityId)
                      {
                        nestedPromises.push(ChiRhosNextApi.EventApi.positionAssign({ toPersonEntityId: assign.entityId, belongsTo: response.data.entity.entityId }).then(
                          response => {
                            console.log('Event position assigned')
                          },
                          async error => {
                            let contentType = error.headers.get("content-type")
                            if (contentType && contentType.indexOf("application/json") !== -1)
                            {
                              await error.json().then(body => {
                                console.log(body.Message)
                                messages.push({ position: position.name, action: 'Assign position', text: body.Message, assign: assign })
                              })
                            }
                            else
                            {
                              await error.text().then(body => {
                                console.log(body)
                                messages.push({ position: position.name, action: 'Assign position', text: parseError(body), assign: assign })
                                })
                            }}
                          ))
                      }
                    })
                  }
                },
                async error => {
                  let contentType = error.headers.get("content-type")
                  if (contentType && contentType.indexOf("application/json") !== -1)
                  {
                    await error.json().then(body => {
                      messages.push({ position: position.name, action: 'Save position', text: body.Message })
                      console.log(body.Message)
                    })
                  }
                  else
                  {
                    await error.text().then(body => {
                      messages.push({ position: position.name, action: 'Save position', text: parseError(body) })
                      console.log(body)
                      })

                  }}
                ))

                // check for positions
              }
            }
            else
            {
              if(position.delete)
              {
                promises.push(ChiRhosNextApi.EventSeriesApi.positionDelete(position.entityId).then(
                response => {
                  console.log('Event series position deleted')
                },
                async error => {
                  let contentType = error.headers.get("content-type")
                  if (contentType && contentType.indexOf("application/json") !== -1)
                  {
                    await error.json().then(body => {
                      messages.push({ position: position.name, action: 'Delete series position', text: body.Message })
                      console.log(body.Message)
                    })
                  }
                  else
                  {
                    await error.text().then(body => {
                      messages.push({ position: position.name, action: 'Delete series position', text: parseError(body) })
                      console.log(body)
                      })

                  }}
                ))
              }
              else
              {
                  promises.push(ChiRhosNextApi.EventSeriesApi.position(position).then(
                  response => {
                    console.log('Event series position saved')
                  },
                  async error => {
                    let contentType = error.headers.get("content-type")
                    if (contentType && contentType.indexOf("application/json") !== -1)
                    {
                      await error.json().then(body => {
                        messages.push({ position: position.name, action: 'Save series position', text: body.Message })
                        console.log(body.Message)
                      })
                    }
                    else
                    {
                      await error.text().then(body => {
                        messages.push({ position: position.name, action: 'Save series position', text: parseError(body) })
                        console.log(body)
                        })
                    }
                  }
                ))
              }
            }
          })

          if(promises.length > 0)
          {
            await Promise.all(promises)

            if(nestedPromises.length > 0)
            {
              await Promise.all(nestedPromises)
            }
          }
        }

        if(this.messages.length === 0)
        {
          this.$emit('editEventPanelClose')
        }
        else
        {
          this.populate() // repopulate with the updated positions
          this.showMessages = true
        }
      }
    },
    parseError(html)
    {
      if(html.indexOf('<div class="titleerror">') >= 0)
      {
        let cropped = html.substring(html.indexOf('<div class="titleerror">') + 24)

        return cropped.substring(0, cropped.indexOf('</div>'))
      }

      return html
    },
    addPosition()
    {
      this.positions.unshift({ create: true, delete: false, entityId: this.generateUUID(), users: [], limit: {}, limitPreset: null })
    },
    removePosition(entityId)
    {
      var item = this.positions.find(function(element) {
        return element.entityId === entityId
      });

      if(item)
      {
        if(item.create)
        {
          this.positions.splice(this.positions.indexOf(item), 1)
        }
        else
        {
          item.delete = true
        }
      }
    },
    generateUUID() { // Public Domain/MIT https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    var d = new Date().getTime()// Timestamp
    var d2 = (performance && performance.now && (performance.now()*1000)) || 0// Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16// random number between 0 and 16
        if(d > 0){// Use timestamp until depleted
            r = (d + r)%16 | 0
            d = Math.floor(d/16)
        } else {// Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0
            d2 = Math.floor(d2/16)
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    });
    },
    addAssign(entityId, value)
    {
      var item = this.positions.find(function(element) {
        return element.entityId === entityId
      });

      if(item)
      {
        var assign = item.users.find(function(element) {
          return element.entityId === value.entityId && !value.delete
        });

        if(assign)
        {
            this.$toast('Person already assigned to this position', 'error')
        }
        else
        {
          if(this.eventForm.start)
          {
            ChiRhosV3Api.EventApi.apiEventPositionBlockCheckByDatePost({ apiCheckBlockRequest: { entityId: value.entityId, pointInTime: moment(this.eventForm.start).utc(), minutesDuration: this.eventForm.durationHours * 60 + this.eventForm.durationMinutes * 1 } }).then(
              response => {
                if(response.data && response.data.entity)
                {
                  value.blocked = response.data.entity.note ? response.data.entity.note : 'Blocked out'
                  value.blocked += ' from ' + moment(response.data.entity.fromUtc).local().format('LLLL') + ' to ' + moment(response.data.entity.toUtc).local().format('LLLL')
                  item.users.unshift(value)
                }
                else
                {
                  value.blocked = ''
                  item.users.unshift(value)
                }
              },
              error => {
                console.error(error)
              }
            )
          }
          else
          {
            value.blocked = ''
            item.users.unshift(value)
          }
        }
      }
    },
    removeAssign(position, user)
    {
      var assign = position.users.find(function(element) {
        return element.entityId === user.entityId
      });

      if(!assign)
      {
          this.$toast('Person not assigned to this position', 'error')
      }
      else
      {
        if(!assign.assignedEntityId)
        {
          position.users.splice(position.users.indexOf(assign), 1)
        }
        else
        {
          // existing, so need to remove
          assign.delete = true
        }
      }

    },
    setPositionLimit(entityId, value)
    {
      var item = this.positions.find(function(element) {
        return element.entityId === entityId
      });

      if(item)
      {
        item.limit = value
      }
    },
    setEventLimit(value)
    {
      this.eventForm.limit = value
    },
    hideMessages()
    {
      this.showMessages = false
    },
    resetAttendance()
    {
      this.attendanceResults = []
      this.attendancePage = 1
    },
    showAttendanceReport()
    {
      this.resetAttendance()

        // let attendanceReport = this.attendanceReport
        // let attendanceResults = this.attendanceResults

        ChiRhosNextApi.EventApi.listInvited({ entityId: this.currentEvent.entityId, requestUnpaged: true, sort: { property: "entity.lastName" }  }).then(
        response => {

          if(response.data)
          {
            switch(this.attendanceReport)
            {
              case 'checkedIn':
                this.attendanceResults = response.data.checkedIn.concat(response.data.checkedOut).map(function(e) {
                  return { firstName: e.person.firstName, lastName: e.person.lastName, entityId: e.person.entityId }
                })
                break
              case 'checkedInNotOut':
                this.attendanceResults = response.data.checkedIn.map(function(e) {
                  return { firstName: e.person.firstName, lastName: e.person.lastName, entityId: e.person.entityId }
                })
                break
              case 'absent':
                this.attendanceResults = response.data.attending.map(function(e) {
                  return { firstName: e.person.firstName, lastName: e.person.lastName, entityId: e.person.entityId }
                }).concat(response.data.notAttending).map(function(e) {
                  return { firstName: e.firstName, lastName: e.lastName, entityId: e.entityId }
                }).concat(response.data.maybeAttending).map(function(e) {
                  return { firstName: e.firstName, lastName: e.lastName, entityId: e.entityId }
                }).concat(response.data.awaitingRsvp).map(function(e) {
                  return { firstName: e.firstName, lastName: e.lastName, entityId: e.entityId }
                })
                break
              case 'absentRsvpYes':
                this.attendanceResults = response.data.attending.map(function(e) {
                  return { firstName: e.firstName, lastName: e.lastName, entityId: e.entityId }
                })
                break
              case 'absentRsvpMaybe':
                this.attendanceResults = response.data.maybeAttending.map(function(e) {
                  return { firstName: e.firstName, lastName: e.lastName, entityId: e.entityId }
                })
                break
              case 'absentRsvpNo':
                this.attendanceResults = response.data.notAttending.map(function(e) {
                  return { firstName: e.firstName, lastName: e.lastName, entityId: e.entityId }
                })
                break
              case 'absentRsvpAwaiting':
                this.attendanceResults = response.data.awaitingRsvp.map(function(e) {
                  return { firstName: e.firstName, lastName: e.lastName, entityId: e.entityId }
                })
                break
            }
          }
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    showBlock(assign)
    {
      alert(assign.blocked)
    },
  },
}
</script>

<style lang="scss"></style>
